import { render, staticRenderFns } from "./Barber.vue?vue&type=template&id=33c020d1&scoped=true"
import script from "./Barber.vue?vue&type=script&lang=js"
export * from "./Barber.vue?vue&type=script&lang=js"
import style0 from "./Barber.vue?vue&type=style&index=0&id=33c020d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c020d1",
  null
  
)

export default component.exports